import { range } from "lodash"
import { CCUtils } from "../../../../common/CCUtils"

const loadMazeImage = (name: string) => CCUtils.asset(`maze/images/${name}`)
const loadGenericImage = (name: string) => CCUtils.asset(`generic/images/${name}`)

export const mazeImages = {
    backButton: loadMazeImage("back-button.png"),
    forwardButton: loadMazeImage("forward-button.png"),
    leftButton: loadMazeImage("left-button.png"),
    rightButton: loadMazeImage("right-button.png"),
    bricks: loadMazeImage("bricks.jpg"),
    grass: loadMazeImage("grass.jpg"),
    cig: loadMazeImage("cigarette.png"),
    ecig: loadGenericImage("ecig-small.png"),
    cigSkin: loadMazeImage("cig-skin.png"),
    ecigSkin: loadMazeImage("ecig-skin.png"),
    transparentPixel: loadGenericImage("transparent-pixel.png"),
    title: loadMazeImage("title.png"),
    nonSmoker: loadMazeImage("non-smoker.png"),
    smoker: loadMazeImage("smoker.png"),
    entranceSign: loadMazeImage("entrance-sign.png"),
    wisps: range(1, 3).map((wispNum) => loadMazeImage(`wisp${wispNum}.png`)),
    puffs: range(1, 3).map((puffNum) => loadMazeImage(`puff${puffNum}.png`)),
    cigLight: loadMazeImage("cig-light.png"),
    timers: range(0, 8).map((timerNum) => loadMazeImage(`timer${timerNum}.png`)),
}
